module.exports = __webpack_public_path__ + "static/media/claims.0df6e081.svg";